import React from 'react';
import ReactDOM from 'react-dom';
import { StoreContext } from 'redux-react-hook';
import { configure as configureLocalizationUtil } from '@vp-dst/localization-util';

import App from './App';
import { getStore } from './state/store';
import './polyfills.ts';
import localizedTextData from './data/localized-text.json';
import websiteContext from './websiteContext';
import { configureNewRelic } from './settings';

// wait for all script to load before bootstrapping our app
// this solves a race-condition where the ui library carousel.js is sometimes not loaded by the time the app tries to render the carousel
window.addEventListener('load', () => {
  // newrelic will only exist on a portion of sessions (40% at the time of writing) in order to keep logging costs down
  // we'll only configure newrelic if it exists on the page
  if (process.env.NODE_ENV === 'production' && newrelic !== undefined) {
    configureNewRelic();
  }

  configureLocalizationUtil({
    siteCulture: websiteContext.getLanguage(),
    localizedTextData,
  });

  ReactDOM.render(
    <StoreContext.Provider value={getStore()}>
      <App />
    </StoreContext.Provider>,
    document.getElementById('root'),
  );
});
